import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import EventGrid from "./EventGrid";

const CategoriesSection = ({ categories = [] }) => {
  const navigate = useNavigate();

  // Take only first 5 categories
  const firstFiveCategories = Array.isArray(categories)
    ? categories.slice(0, 5)
    : [];

  const [activeCategory, setActiveCategory] = useState(null);

  // Set first category as default
  useEffect(() => {
    if (firstFiveCategories.length > 0) {
      setActiveCategory(firstFiveCategories[0].categoryId);
    }
  }, [categories]);

  if (!Array.isArray(categories) || categories.length === 0) return null;

  const selectedCategory = firstFiveCategories.find(
    (cat) => cat.categoryId === activeCategory
  );

  return (
    <div className="max-w-[1300px] mx-auto px-0 py-4">

      {/* Title */}
      <h2 className="text-3xl font-semibold font-['Inter'] text-left mb-8">
        Our Categories
      </h2>

      {/* Header Row */}
      <div className="flex justify-between items-start mb-2">

        {/* Left - Category Tabs */}
        <div className="flex gap-12 flex-wrap items-start">
          {firstFiveCategories.map((category) => (
            <div
              key={category.categoryId}
              onClick={() => setActiveCategory(category.categoryId)}
              className="cursor-pointer flex flex-col"
            >
              <span
                className={`text-base font-medium uppercase transition ${
                  activeCategory === category.categoryId
                    ? "text-black"
                    : "text-neutral-500"
                }`}
              >
                {category.categoryName}
              </span>

              {activeCategory === category.categoryId && (
                <div className="w-14 h-0.5 bg-black mt-2" />
              )}
            </div>
          ))}
        </div>

        {/* Right - All Categories */}
        <div
         onClick={() => navigate("/categories")
         }
          className="px-4 py-1.5 bg-stone-300 cursor-pointer rounded-lg hover:bg-stone-400 transition"
        >
          <span className="text-black text-sm font-normal uppercase">
            All Categories
          </span>
        </div>
      </div>

      {/* Events Grid */}
       <EventGrid
              title={""}
              events={selectedCategory?.events}
              limit={5}
              showViewAll={true}
            />
    </div>
  );
};

export default CategoriesSection;